<template>
  <CRow>
    <CCol col="12" xl="12">
        <CButtonToolbar>
          <CButton 
            color="ghost-success" 
            shape="pill"
            @click="showSectionEditor=true"
          >
            <CIcon size="lg" name="cil-pen"/>
          </CButton>
        </CButtonToolbar>
      </CCol>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <AppForm 
            :key="appFormKey"
            :vo-name="isEdit ? 'CourseGetVo' : 'CourseAddVo'"
            :data="tmpCourse" 
            @changed="onFormChange"
          />
        </CCardBody>
        <CCardFooter>
          <LoadingStateButton
            @click="onAddOrUpdateCourse"
            :text="i18nMessage.Apply"
            color="primary"
            :loading="updateCourseLoading"
          />
          <template v-if="isEdit">
            &nbsp;
            <CButton color="secondary" @click="showDeleteModal = true">{{i18nMessage.Delete}}</CButton>
          </template>
          &nbsp;
          <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
    <CModal
      :show.sync="showDeleteModal"
      :centered="true"
      color="default"
    >
      {{i18nMessage.PleaseInputTextToConfirmDelete}} <b>{{course.name}}</b>
      <br/><br/>
      <CInput
          :placeholder="i18nMessage.PleaseInputText"
          v-model="deleteConfirmText"
        />
      <template #header>
        <span class="modal-title">{{i18nMessage.Delete}}？</span>
        <CButtonClose @click="showDeleteModal = false" class="text-dark"/>
      </template>
      <template #footer>
        <LoadingStateButton
          :disabled="deleteConfirmText !== course.name"
          @click="onDeleteCourse"
          :text="i18nMessage.Apply"
          color="danger"
          :loading="deleteCourseLoading"
        />
        <CButton @click="showDeleteModal = false" color="secondary">{{i18nMessage.Cancel}}</CButton>
      </template>
    </CModal>
    <CModal
      :addContentClasses="'overlay bg-white section-modal'"
      :fade="false"
      id="section-editor-modal"
      title="Section Editor"
      :show.sync="showSectionEditor"
    >
      <HtmlEditor
        id="section-editor"
        v-if="showSectionEditor"
        :content="(tmpCourse.desc_html ? tmpCourse.desc_html  : ' ') + '<style>' + (tmpCourse.desc_style ? tmpCourse.desc_style : '') + '</style>'"
        :global-styles="defaultGlobalStyles"
        @change="onEditorContentChange"
      />
    </CModal>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'
import HtmlEditor from '../../components/HtmlEditor'

export default {
  name: 'Course',
  components: {
    AppForm,
    LoadingStateButton,
    HtmlEditor,
  },
  data () {
    return {
      deleteConfirmText: null,
      showDeleteModal: false,
      isEdit: this.$route.params.id && this.$route.params.id.length > 0,
      tmpCourse: {},
      updateCourseLoading: false,
      deleteCourseLoading: false,
      appFormKey: generateGUID(),
      showSectionEditor: false,
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      course: state => state.course.course,
      defaultGlobalStyles: state => state.defaultGlobalStyles,
    }),
  },
  methods: {
    ...mapActions({
      getCourse: 'course/getCourse',
      updateCourse: 'course/updateCourse',
      addCourse: 'course/addCourse',
      deleteCourse: 'course/deleteCourse',
    }),
    ...mapMutations({
      setCourse: 'course/setCourse',
    }),
    goBack() {
      this.$router.push({path: '/course'})
    },
    onFormChange (data) {
      this.tmpCourse = {...data}
    },
    onEditorContentChange (template, style) {
      this.tmpCourse = {
        ...this.tmpCourse,
        desc_html: template,
        desc_style: style,
      }
    },
    onAddOrUpdateCourse () {
      if (this.tmpCourse.id) {
        this.updateCourseLoading = true
        this.updateCourse(this.tmpCourse)
          .then(() => {
            this.updateCourseLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateCourseLoading = false
          })
      } else {
        this.updateCourseLoading = true
        this.addCourse(this.tmpCourse)
          .then(() => {
            this.updateCourseLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateCourseLoading = false
          })
      }
    },
    onDeleteCourse () {
      this.deleteCourseLoading = true
      this.deleteCourse(this.course.id)
          .then(() => {
            this.deleteCourseLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.deleteCourseLoading = false
            this.showDeleteModal = false
          })
    }
  },
  mounted() {
    if (this.isEdit) {
      this.getCourse(this.$route.params.id).then(() => {
        this.tmpCourse = this.course
      })
    }
  },
  destroyed() {
    this.setCourse({})
  }
}
</script>

<style>
  .section-modal.overlay {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(51,51,51,0.7);
    z-index: 10;
  }

  .section-modal > .modal-header {
    padding: 5px;
  }

  .section-modal > .modal-content {
    overflow: hidden;
  }

  .section-modal > .modal-body {
    overflow-y: scroll;
    padding: 0px;
  }

  .section-modal > .modal-footer {
    display: none;
  }
</style>